"use client";

import { FileTextIcon } from "lucide-react";
import { isChatAttachmentDataPart } from "@/lib/ai/chat-attachments";
import type { MessageRenderGroup } from "./render-model";

const chipClassName =
  "flex min-w-0 max-w-full items-center gap-2 rounded-md border bg-muted/30 px-3 py-2 text-xs";

/** live file と永続化 attachment を同じ見た目で表示する。 */
export function AttachmentsGroup({
  group,
}: {
  group: Extract<MessageRenderGroup, { kind: "attachments" }>;
}) {
  return group.parts.map(({ part, partIndex }) => {
    const attachment = isChatAttachmentDataPart(part)
      ? part.data
      : { filename: part.filename ?? part.url, mediaType: part.mediaType };
    return (
      <div className={chipClassName} key={`attachment-${partIndex}`}>
        <FileTextIcon className="size-4 shrink-0 text-muted-foreground" />
        <span className="truncate font-medium">
          {attachment?.filename ?? "Attachment"}
        </span>
        <span className="shrink-0 text-muted-foreground">
          {attachment?.mediaType ?? ""}
        </span>
      </div>
    );
  });
}
